import React, { useContext, useEffect } from 'react'
import { Container, ElementImage, ElementName, Section, SectionElement, SectionElements, SectionTitle, StyledLink } from './style'
import arrow from '../../../assets/home/arrow.svg'
import { TypeMainOutlet } from '..'
import { useOutletContext } from 'react-router-dom'
import UserContext, { Roles } from '../../../contexts/UserContext'
import { useTenant } from '../../../contexts/TenantContext'
import { getModulesBySectionWithPermissions, getModulesForTenant, hasModulePermission, ModuleConfig } from '../../../config/modulesByTenant'
import CreateOrdenoCustomer from '../../../components/CreateOrdenoCustomer'
import SectionContext from '../../../contexts/SectionContext'

const HomeScreen:React.FC = () => {
  const { setSearch } = useOutletContext<TypeMainOutlet>()
  const { user } = useContext(UserContext)
  const { tenantId } = useTenant()
  const { permissions } = useContext(SectionContext)
  
  useEffect(() => {
    setSearch('')
  }, [])

  console.log('HomeScreen Debug:', {
    hasUser: !!user,
    userId: user?.id,
    userSub: user?.sub,
    userRole: user?.role,
    userPermissions: user?.permissions,
    sectionPermissions: permissions,
    tenantId,
    hasUserPermissions: Array.isArray(user?.permissions) && user.permissions.length > 0,
    hasSectionPermissions: Array.isArray(permissions) && permissions.length > 0,
    finalPermissionsWillBe: (
      user?.permissions && Array.isArray(user.permissions) && user.permissions.length > 0
        ? 'token permissions'
        : permissions && Array.isArray(permissions) && permissions.length > 0
        ? 'section permissions'
        : tenantId === 2 ? 'fashion fallback' : 'industrial fallback'
    )
  })

  // Se tenantId for explicitamente null, aguardamos (evita tratar 0 como ausente)
  if (tenantId === null) {
    return <Container>Carregando tenant...</Container>
  }

  // Determinar permissões finais
  let finalPermissions: string[]
  
  if (user?.permissions && Array.isArray(user.permissions) && user.permissions.length > 0) {
    finalPermissions = user.permissions
    console.log('Usando permissões do token:', finalPermissions)
  } else if (permissions && Array.isArray(permissions) && permissions.length > 0) {
    finalPermissions = permissions
    console.log('Usando permissões do SectionContext:', finalPermissions)
  } else {
    console.log('Usuário sem permissões definidas')
    
    // Retornar tela de sem permissões
    return (
      <Container>
        <div style={{
          padding: '40px 20px',
          textAlign: 'center',
          color: '#666',
          fontSize: '16px'
        }}>
          <h3 style={{ color: '#d32f2f', marginBottom: '16px' }}>Acesso Negado</h3>
          <p style={{ marginBottom: '8px' }}>Usuário sem permissões definidas.</p>
          <p style={{ marginBottom: '16px' }}>Entre em contato com o administrador do sistema.</p>
          <p style={{ fontSize: '14px', color: '#999' }}>
            Usuário: {user?.name || user?.email || 'N/A'} (ID: {user?.sub || 'N/A'})
          </p>
        </div>
      </Container>
    )
  }

  console.log('🎯 Permissões finais carregadas:', finalPermissions)

  const modulesBySection = getModulesBySectionWithPermissions(tenantId, finalPermissions)
  
  if (Object.keys(modulesBySection).length === 0) {
    return <Container>Nenhum módulo disponível para suas permissões</Container>
  }
  
  return(
    <Container>
      {user.role == Roles.globalAdmin ? (
        <CreateOrdenoCustomer />
      ) : (
        <>
          {Object.entries(modulesBySection).map(([sectionName, modules]) => (
            <Section key={sectionName}>
              <SectionTitle>{sectionName}</SectionTitle>
              <SectionElements>
                {modules.map((module, index) => (
                  <StyledLink key={index} to={`/panel/${module.path}`}>
                    <SectionElement>
                      <ElementImage src={module.image} alt='icon'/>
                      <ElementName>{module.name}</ElementName>
                      <ElementImage className='arrow' src={arrow} alt='arrow-icon'/>
                    </SectionElement>
                  </StyledLink>
                ))}
              </SectionElements>
            </Section>
          ))}
        </>
      )}
    </Container>
  )
}

export default HomeScreen